// extracted by mini-css-extract-plugin
export default {"small":"HorizontalSpacer_small__uICQI","medium":"HorizontalSpacer_medium__wVlcb","large":"HorizontalSpacer_large__BTzoL","XL":"HorizontalSpacer_XL__3d+iC"};